import { render, staticRenderFns } from "./Nation.vue?vue&type=template&id=ade7dee2&scoped=true&"
import script from "./Nation.vue?vue&type=script&lang=js&"
export * from "./Nation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade7dee2",
  null
  
)

component.options.__file = "Nation.vue"
export default component.exports